import React from 'react';
import { Modal, Button } from '@block/plug';
import './style.scss';

// 图片预览Modal组件
export const ImagePreviewModal = ({ visible, imageUrl, title, onClose }) => {
  if (!visible) return null;

  return (
    <Modal title={title || '图片预览'} onClose={onClose} style={{ width: '800px' }}>
      <Modal.Body>
        <div className="image-preview-container">
          <img src={imageUrl} alt={title} className="preview-image" />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onClose}>关闭</Button>
      </Modal.Footer>
    </Modal>
  );
};
